import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useCallback, useEffect, useContext, useState } from 'react';
import { OrderList } from './List';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { FoodOrder } from '../../FoodOrder/rn';
import { TabsType } from '../../Tabs/rn';
import { BUYER_ORDER_LIST_TITLE_TEXT, GROUP_ORDER_TEXT } from '../../../utils/constants';
import { useLocale } from '../../LocaleProvider/rn';
import { Popup } from '../../Popup/rn';
import { FoodBuyerOrder } from '../../FoodBuyerOrder/rn';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
import { View, Text, Dimensions } from 'react-native';
import styles from './styles';
import { NestedTabs } from '../../Tabs/rn/NestedTabs';
export { showElement } from './showElement';
export var OrderType;
(function (OrderType) {
  OrderType["food"] = "food";
  OrderType["buyerFood"] = "buyerFood";
})(OrderType || (OrderType = {}));
var prefixCls = 'order-list-popup';
export var OrderListPopup = function OrderListPopup(props) {
  var _renderOrderMap;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var onLoadMore = props.onLoadMore,
    onSelectOrder = props.onSelectOrder,
    componentTrackingData = props.componentTrackingData,
    showLoading = props.showLoading,
    panelTitleText = props.panelTitleText,
    _props$groupOrderText = props.groupOrderText,
    groupOrderText = _props$groupOrderText === void 0 ? trans(GROUP_ORDER_TEXT) || 'Group Order' : _props$groupOrderText,
    onClosePopup = props.onClosePopup,
    loadMoreParams = props.loadMoreParams,
    limit = props.limit,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? OrderType.food : _props$orderCardType,
    listWrapperStyle = props.listWrapperStyle,
    orderCardStyle = props.orderCardStyle,
    active = props.active,
    container = props.container,
    showTabs = props.showTabs,
    _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? [] : _props$tabs,
    selectOrderText = props.selectOrderText,
    renderByShow = props.renderByShow;
  var context = useContext(ConfigContext);
  var _useState = useState(Date.now()),
    _useState2 = _slicedToArray(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useComponentTracking = useComponentTracking({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    closePanelTrackingData = _useComponentTracking.result.closePanel;
  var handleCloseTracking = function handleCloseTracking() {
    var _closePanelTrackingDa;
    var trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
      view_duration: Math.floor((Date.now() - showTime) / 1000)
    });
    (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick) && tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
      data: trackingData
    }));
  };
  useEffect(function () {
    if (active) {
      // popup弹出时重新设置 开始展示的时间
      setShowTime(Date.now());
    }
  }, [active]);
  var handleClosePopup = function handleClosePopup() {
    handleCloseTracking();
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
  };
  var handleSelectOrder = function handleSelectOrder(order) {
    handleCloseTracking();
    onSelectOrder === null || onSelectOrder === void 0 ? void 0 : onSelectOrder(order);
  };
  var onClickDriverOrder = function onClickDriverOrder(order) {
    var _context$eventEmitter, _context$eventEmitter2;
    var action = order.action,
      orderId = order.orderId;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      text: orderId === null || orderId === void 0 ? void 0 : orderId.toString(),
      action: action
    }, action.callback));
    handleSelectOrder(order);
  };
  var renderFoodOrder = useCallback(function (item, index) {
    var _item$groupOrders;
    if ((_item$groupOrders = item.groupOrders) !== null && _item$groupOrders !== void 0 && _item$groupOrders.length) {
      return /*#__PURE__*/React.createElement(View, {
        style: styles["".concat(prefixCls, "-group-order-wrapper")]
      }, groupOrderText ? /*#__PURE__*/React.createElement(Text, {
        style: styles["".concat(prefixCls, "-banner")]
      }, groupOrderText) : null, item.groupOrders.map(function (order) {
        return /*#__PURE__*/React.createElement(FoodOrder, _extends({}, order, {
          index: index,
          key: order.orderId,
          onClick: function onClick() {
            return onClickDriverOrder(order);
          },
          componentTrackingData: componentTrackingData,
          wrapperStyle: [orderCardStyle, {
            marginBottom: 0
          }],
          bannerStyle: styles['food-order-banner']
        }));
      }));
    }
    return /*#__PURE__*/React.createElement(FoodOrder, _extends({}, item, {
      index: index,
      key: item.orderId,
      onClick: function onClick() {
        return onClickDriverOrder(item);
      },
      componentTrackingData: componentTrackingData,
      wrapperStyle: [orderCardStyle, {
        marginBottom: 10
      }],
      bannerStyle: styles['food-order-banner']
    }));
  }, [props]);
  var renderFoodBuyerOrder = useCallback(function (item, index, tab) {
    return /*#__PURE__*/React.createElement(FoodBuyerOrder, _extends({}, item, {
      index: index,
      tab: tab,
      selectOrderText: selectOrderText,
      onSelectOrder: function onSelectOrder() {
        return handleSelectOrder(item);
      },
      componentTrackingData: componentTrackingData,
      wrapperStyle: [{
        width: '100%'
      }]
    }));
  }, [props]);
  var renderOrderMap = (_renderOrderMap = {}, _defineProperty(_renderOrderMap, OrderType.food, renderFoodOrder), _defineProperty(_renderOrderMap, OrderType.buyerFood, renderFoodBuyerOrder), _renderOrderMap);
  return /*#__PURE__*/React.createElement(Popup, {
    title: panelTitleText || trans(BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: active,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleStyle: styles["".concat(prefixCls, "-title")],
    contentContainerStyle: styles["".concat(prefixCls, "-content")],
    contentStyle: {
      padding: 0,
      paddingBottom: 20,
      backgroundColor: '#f5f5f5',
      height: Dimensions.get('window').height * 0.8
    },
    contentScrollable: false,
    delayBeforeContentShow: 300,
    container: container,
    renderByShow: renderByShow
  }, showTabs ? /*#__PURE__*/React.createElement(NestedTabs, {
    tabs: tabs,
    containerStyle: styles["".concat(prefixCls, "-tabs-content-class")],
    titleContainerStyle: styles["".concat(prefixCls, "-tabs-title-class")],
    defaultSelected: 0,
    titleStyle: {
      textAlign: 'center',
      width: tabs.length ? Dimensions.get('window').width / tabs.length : '100%'
    },
    type: TabsType.underscore,
    renderTab: function renderTab(props) {
      var tab = tabs.find(function (t) {
        return t.type === props.status;
      });
      return /*#__PURE__*/React.createElement(OrderList, {
        key: props.status,
        active: props.status === props.currentStatus,
        tab: tab,
        limit: limit,
        loadMoreParams: loadMoreParams,
        showLoading: showLoading,
        onLoadMore: onLoadMore,
        renderOrder: renderOrderMap[orderCardType],
        componentTrackingData: componentTrackingData
      });
    }
  }) : /*#__PURE__*/React.createElement(View, {
    style: [styles["".concat(prefixCls, "-list-wrapper")], listWrapperStyle]
  }, /*#__PURE__*/React.createElement(OrderList, {
    limit: limit,
    loadMoreParams: loadMoreParams,
    showLoading: showLoading,
    onLoadMore: onLoadMore,
    componentTrackingData: componentTrackingData,
    renderOrder: renderOrderMap[orderCardType]
  })));
};